// extracted by mini-css-extract-plugin
module.exports = {"crossSiteLabel":"Nh","zenCrossSiteLabel":"Oh","vrsnlCrossSiteLabel":"Ph"};